import React from 'react';

import '../programLang/programLang.scss';

const Contact = () => {
	return(
		<div className="container" >
			<h3 id="header">
				felipechoi97@gmail.com
			</h3>
		</div>
	);
}

export default Contact;